import React from 'react'
import { InputText } from 'components/atoms'
import styled, { AnyStyledComponent } from 'styled-components'
interface ICoordinate {
  pickup_latitude: string | number | null
  pickup_longitude: string | number | null
}

interface IProps {
  google: any
  editable: boolean
  value: string
  coordinate: ICoordinate
  onChangeLocation: (value: string) => void
  onChangeCoordinate: (coordinate: ICoordinate) => void
}

const OtaReservationPickupLocation: React.FC<IProps> = ({
  google,
  editable,
  value,
  coordinate,
  onChangeLocation,
  onChangeCoordinate,
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null)
  const mapRef = React.useRef<HTMLDivElement>(null)
  const mapInstanceRef = React.useRef<any>(null)
  const markerRef = React.useRef<any>(null)
  const autocompleteRef = React.useRef<any>(null)
  const setMapElement = React.useCallback((element: HTMLDivElement | null) => {
    if (mapRef.current !== element) {
      mapRef.current = element
      mapInstanceRef.current = null
      markerRef.current = null
    }
  }, [])

  React.useEffect(() => {
    if (!google || !coordinate.pickup_latitude || !coordinate.pickup_longitude || !mapRef.current) {
      return
    }

    const position = new google.maps.LatLng(
      Number(coordinate.pickup_latitude),
      Number(coordinate.pickup_longitude)
    )
    if (!mapInstanceRef.current) {
      mapInstanceRef.current = new google.maps.Map(mapRef.current, {
        zoom: 15,
        center: position,
        mapTypeId: 'roadmap',
        scrollwheel: false,
        draggable: false,
      })
      markerRef.current = new google.maps.Marker({
        position,
        title: 'pickup_location',
        map: mapInstanceRef.current,
      })
      return
    }

    mapInstanceRef.current.panTo(position)
    markerRef.current?.setPosition(position)
  }, [editable, google, coordinate.pickup_latitude, coordinate.pickup_longitude])

  React.useEffect(() => {
    if (!google || !editable || !inputRef.current || autocompleteRef.current) {
      return
    }

    const autocomplete = new google.maps.places.Autocomplete(inputRef.current)
    const listener = autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace()
      const location = place?.geometry?.location
      if (!location) {
        return
      }

      onChangeLocation(place.formatted_address || inputRef.current?.value || '')
      onChangeCoordinate({
        pickup_latitude: location.lat(),
        pickup_longitude: location.lng(),
      })
    })
    autocompleteRef.current = autocomplete

    return () => {
      listener.remove()
      autocompleteRef.current = null
    }
  }, [editable, google, onChangeCoordinate, onChangeLocation])

  const hasCoordinate = coordinate.pickup_latitude && coordinate.pickup_longitude

  return (
    <PickupLocationWrapper>
      {editable ? (
        <InputText
          name="pickup_location"
          value={value}
          inputRef={inputRef}
          onChangeHandler={event => {
            onChangeLocation(event.target.value)
            onChangeCoordinate({ pickup_latitude: null, pickup_longitude: null })
          }}
        />
      ) : (
        <span>{value || '-'}</span>
      )}
      {hasCoordinate && <div ref={setMapElement} className="map" />}
    </PickupLocationWrapper>
  )
}

export default OtaReservationPickupLocation

const PickupLocationWrapper: AnyStyledComponent = styled.div`
  width: 100%;

  .map {
    height: 320px;
    margin-top: 12px;
  }
`
